import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Modal from 'react-modal'
import numeral from 'numeral'

import { convertFilesToFolderStructure } from 'Utils/BatchUploaderHelpers'
import TableHeaders from 'Pods/Shared/Table/TableHeaders'
import SharedTable from 'Pods/Shared/Table/SharedTable'
import Icon from 'Pods/Shared/Icon/Icon'

import ChildRow from './ChildRow'

const formatsColumnIndex = 4
const statusColumnIndex = 2
const imagesColumnIndex = 5

class FoldersStructureReviewModal extends React.Component {
  constructor() {
    super()

    this.state = {
      table: {
        className: null,
        select: false,
        headers: [],
        rows: [],
        colgroup: [],
      },
      headers: [
        {
          value: 'upload_order_number', title: '#', sortable: false, centered: true,
        },
        {
          value: 'folder_name', title: 'Folder name', sortable: true, centered: false,
        },
        {
          value: 'status', title: 'Status', sortable: true, centered: false,
        },
        {
          value: 'total_files', title: 'Total files', sortable: true, centered: false,
        },
        {
          value: 'formats', title: 'Formats', sortable: true, centered: false,
        },
        {
          value: 'images', title: 'Images', sortable: true, centered: false,
        },
        {
          value: 'size', title: 'Size', sortable: true, centered: false,
        },
        {
          value: 'expand', title: '', sortable: false, centered: false,
        },
      ],
      sortingFilters: { sortBy: ['status', 'asc'] },
      selectedRows: [],
      disabledRows: [],
      selectAll: false,
    }

    this.onSortingChange = this.onSortingChange.bind(this)
    this.onExpandClick = this.onExpandClick.bind(this)
    this.modelsToUpload = this.modelsToUpload.bind(this)
    this.onSelectAll = this.onSelectAll.bind(this)
    this.onCheckboxClick = this.onCheckboxClick.bind(this)
  }

  componentWillReceiveProps() {
    this.makeTable(this.props.files)
  }

  componentDidMount() {
    this.makeTable(this.props.files)
  }

  makeTable(files) {
    const structure = this.modelsToUpload(files)

    const rows = structure.map((row, index) => {
      const folderSize = numeral(row.files.map((file) => file.size).concat(
        row.images.map((file) => file.size)
      ).concat(row.other.map((file) => file.size)).reduce((a, b) => { return a + b; }, 0)).format('0.0b')

      const folderStatus = (row) => {
        if (row.isValid) {
          return ({ text: 'Ready to upload', textClass: 'text-green', icon: 'check-circle' })
        } if (row.files.length === 0) {
          return ({ text: 'Error: Folder does not contain any files', textClass: 'text-warning', icon: 'times-circle' })
        }
        return (
          { text: 'Notice: Folder does not contain any images', textClass: 'text-orange', icon: 'exclamation-circle' }
        )
      }

      return {
        id: row.id,
        child: <ChildRow images={row.images} formats={row.files} />,
        childExpanded: false,
        columns: [{
          content: `${index + 1}.`,
          customClass: 'u-text-center',
        }, {
          content: row.folderName.length > 50 ? `${row.folderName.substr(0, 50)}...` : row.folderName,
          customClass: 'product-text__title',
          contentStr: row.folderName,
        }, {
          content: <div><Icon type={['far', folderStatus(row).icon]} />{folderStatus(row).text}</div>,
          customClass: `product-text__status text-semibold ${folderStatus(row).textClass}`,
          contentStr: folderStatus(row).text,
        }, {
          content: row.files.length + row.images.length,
          customClass: `${row.files.length + row.images.length === 0 ? 'text-semibold text-warning' : ''} u-text-center`,
          contentStr: row.files.length + row.images.length,
        }, {
          content: row.files.length,
          customClass: `${row.files.length === 0 ? 'text-semibold text-warning' : ''} u-text-center`,
          contentStr: row.files.length,
        }, {
          content: row.images.length,
          customClass: `${row.images.length === 0 ? 'text-semibold text-warning' : ''} u-text-center`,
          contentStr: row.images.length,
        }, {
          content: folderSize,
          customClass: 'u-text-center',
          contentStr: folderSize,
        }, {
          content: row.files.length + row.images.length > 0 && <Icon type={['fas', 'caret-down']} className="expansion-caret" notSpaced />,
          customClass: 'u-text-center',
        }],
      }
    }).sort((a, b) => {
      return a.columns[statusColumnIndex].contentStr.localeCompare(b.columns[statusColumnIndex].contentStr)
    })

    this.setState({
      table: {
        className: 'table-with-borders table-with-borders--compact products-listing',
        select: true,
        headers: false,
        rows,
        colgroup: ['4%', '5%', '27%', '27%', '8%', '8%', '8%', '8%', '5%'],
      },
      disabledRows: rows.filter(row => row.columns[formatsColumnIndex].content === 0),
      selectedRows: rows.filter(row => row.columns[formatsColumnIndex].content !== 0 && row.columns[imagesColumnIndex].content !== 0),
      selectAll: true,
    })
  }

  onSortingChange(newFilters) {
    const newState = this.state
    const filterIndex = {
      folder_name: 1,
      status: 2,
      total_files: 3,
      formats: 4,
      images: 5,
      size: 6,
    }[newFilters.sortBy[0]]

    newState.sortingFilters = newFilters

    newState.table.rows = this.state.table.rows.sort((a, b) => {
      if (newFilters.sortBy[1] === 'asc') {
        if (['total_files', 'formats', 'images', 'size'].includes(newFilters.sortBy[0])) {
          return numeral(a.columns[filterIndex].contentStr)._value - numeral(b.columns[filterIndex].contentStr)._value
        }
        return a.columns[filterIndex].contentStr.localeCompare(b.columns[filterIndex].contentStr)
      } if (['total_files', 'formats', 'images', 'size'].includes(newFilters.sortBy[0])) {
        return numeral(b.columns[filterIndex].contentStr)._value - numeral(a.columns[filterIndex].contentStr)._value
      }
      return b.columns[filterIndex].contentStr.localeCompare(a.columns[filterIndex].contentStr)
    })

    this.setState(newState)
  }

  onExpandClick(index) {
    const newState = this.state
    const targetedRow = newState.table.rows.find((row) => row.id === index)

    if ((targetedRow.child.props.formats.length + targetedRow.child.props.images.length) === 0) {
      return null
    }
    targetedRow.childExpanded = !targetedRow.childExpanded
    this.setState(newState)
  }

  onSelectAll() {
    if (this.state.selectAll) {
      this.setState({
        selectAll: false,
        selectedRows: [],
      })
    } else {
      const list = this.state.selectedRows

      list.length = 0

      this.state.table.rows.filter(row => row.columns[formatsColumnIndex].content !== 0).map((value) => list.push(value))

      this.setState({
        selectAll: true,
        selectedRows: list,
      })
    }
  }

  onCheckboxClick(id) {
    const model = this.state.selectedRows.filter(item => item.id === id)

    if (model.length > 0) {
      this.setState(prevState => ({
        selectedRows: prevState.selectedRows.filter(item => item.id !== id),
        selectAll: false,
      }))
    } else {
      const model = this.state.table.rows.filter(item => item.id === id)
      const list = this.state.selectedRows

      list.push(model[0])

      this.setState({
        selectedRows: list,
        selectAll: list.length === this.state.table.rows.filter(row => row.columns[formatsColumnIndex].content !== 0).length,
      })
    }
  }

  modelsToUpload(files) {
    return convertFilesToFolderStructure(files, this.props.imageExtensions, this.props.fileExtensions)
  }

  render() {
    const btnDisabled = this.state.selectedRows.length === 0 ? 'disabled' : ''

    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        onRequestClose={this.props.closeModal}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="overlay-modal overlay-modal--folders-structure-review">
          <header>
            <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.props.closeModal}>
              <Icon type={['fal', 'times']} color="grey-dark" />
            </button>
            <div className="header-text">
              <div className="section__title">Review and Upload</div>
              <p className="text-default">
                You are about to upload <span className="text-semibold text-dark">{this.state.table.rows.length}</span> models to CGTrader.
                This step lets you check whether we have correctly identified your files and model file structure.
                We found <span className="text-semibold text-dark">{this.modelsToUpload(this.props.files).filter(folder => !folder.isValid).length}</span> models
                that require your immediate attention.
              </p>
            </div>
            <table width="100%" className="table-with-borders">
              <colgroup>
                {this.state.table.colgroup.map((col, id) => <col key={id+col} style={{ width: col }} />)}
              </colgroup>
              <TableHeaders
                headers={this.state.headers}
                sortingChange={this.onSortingChange}
                sortingFilters={this.state.sortingFilters}
                selectAll={this.onSelectAll}
                isSelected={this.state.selectAll}
              />
            </table>
          </header>
          <div className="overlay-modal__content">
            <SharedTable
              table={this.state.table}
              onRowClick={this.onExpandClick}
              onCheckboxClick={this.onCheckboxClick}
              selectedRows={this.state.selectedRows}
              disabledRows={this.state.disabledRows}
            />
          </div>
          <div className="overlay-modal__footer">
            <div className="footer__info u-text-left">
              <span className="text-dark"><Icon type={['far', 'file']} />Total: {this.state.table.rows.length}</span>
              <span className="text-green"><Icon type={['far', 'check-circle']} />
                Ready: {this.modelsToUpload(this.props.files).filter(folder => folder.isValid).length}
              </span>
              <span className="text-orange"><Icon type={['far', 'exclamation-circle']} />
                Notice: {this.modelsToUpload(this.props.files).filter(folder => folder.files.length > 0 && folder.images.length === 0).length}
              </span>
              <span className="text-warning"><Icon type={['far', 'times-circle']} />
                Error: {this.modelsToUpload(this.props.files).filter(folder => folder.files.length === 0).length}
              </span>
            </div>
            <div className="footer__action u-text-right">
              <Link
                to="/profile/models"
                state={{
                  modelsToUpload: this.modelsToUpload(this.props.files).filter(folder => this.state.selectedRows.map(row => row.id).includes(folder.id)),
                  batchUploadId: this.props.batchUploadId,
                }}
                className={`btn btn-primary ${btnDisabled}`}
                id="upload-models"
              >Upload {this.state.selectedRows.length}/{this.state.table.rows.length} models
              </Link>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

FoldersStructureReviewModal.propTypes = {
  batchUploadId: PropTypes.string.isRequired,
  files: PropTypes.array.isRequired,
  imageExtensions: PropTypes.array.isRequired,
  fileExtensions: PropTypes.array.isRequired,
}

export default FoldersStructureReviewModal
